import React from 'react';
import { useIonRouter } from '@ionic/react';
import { CourseInfo } from '@/utils/courseUtils';

interface WelcomeBannerProps {
  userName: string;
  showBack?: boolean;
  data: CourseInfo;
}

export const WelcomeBanner: React.FC<WelcomeBannerProps> = ({
  userName,
  showBack = false,
  data
}) => {
  const router = useIonRouter();
  const welcomeText = showBack ? 'Welcome back' : 'Welcome';

  const handleStartLearning = () => {
    router.push(data.buttonRoute, 'forward');
  };

  return (
    <section
      className="flex w-full flex-col items-stretch justify-center p-2.5 max-md:max-w-full"
      data-tour="welcome-banner"
    >
      <div className="bg-[#D44D5C] flex w-full items-center gap-x-6 gap-y-10 overflow-hidden justify-between flex-wrap px-3 py-3 rounded-[10px] max-md:max-w-full">
        <div className="self-stretch min-w-60 w-[403px] my-auto">
          <div className="text-white text-2xl font-semibold font-heading">
            {userName ? `${welcomeText}, ${userName}!` : `${welcomeText}!`}
          </div>
          <p className="text-white text-sm font-medium mt-[8px]">
            {data.welcomeMessage}
          </p>
        </div>
        <button
          onClick={handleStartLearning}
          className="bg-white/40 shadow-[0px_1px_0px_rgba(0,0,0,0.05)] self-stretch flex min-h-8 items-center gap-2 text-sm text-white font-medium justify-center my-auto px-4 py-1.5 rounded-lg hover:bg-white/50 transition-colors"
        >
          Let's start learning
        </button>
      </div>
    </section>
  );
};
